var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('card',{attrs:{"title":_vm.warehouse ? _vm.warehouse.name : ''}},[_c('warehouse-products-to-order-table',{attrs:{"products":_vm.products,"sortable":_vm.sortable,"hideable-columns":_vm.hideableColumns},on:{"sortBy":_vm.sortBy}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }